import Cookies from 'js-cookie';
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Variables } from '../../Variables1/Variables';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import CustomSnipper from '../../components/customSnipper';
import { Button, Form, Spinner, Row, Col ,Image, FormCheck, Card } from 'react-bootstrap';

const ManageContact = (props) => {
    const ContactRouteId = useParams();
    const navigate = useNavigate();
    const token = Cookies.get("token");
  //   const [Permissions, setPermissions] = useState(
  //     Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  //   );
  
    const [contactId, setContactId] = useState(
      Number(ContactRouteId.ContactRouteId) || 0
    );
  
    const [loader, setLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
  
    const [contactExist, setContactExist] = useState(null);
  
  
    // const [title, setTitle] = useState(null);
    // const [date, setDate] = useState(null);
    // const [isPublished, setIsPublished] = useState(null);
    // const [text, setText] = useState(null);
  
    const [contactDetails, setContactDetails] = useState({
      ContactId: 0,
      Number: "",
      IsPublished: true,
      ImageUrl: "",
     
    });
  
  
    const [image, setImage] = useState("");
    const [imageToDb, setImageToDb] = useState("");
  
  //   const [thumbnail, setThumbnail] = useState("");
  //   const [thumbnailToDb, setThumbnailToDb] = useState("");
  
  // get Contact details
  const GetContactDetails = async () => {
      let response = await fetch(
        Variables.API_URL + "Contact/GetContactDetails/" + contactId,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      let result = await response.json();
      if (response.status === 200) {
        setContactDetails({
          ContactId: result.ContactId,
          Number: result.Number,
          IsPublished: result.IsPublished,
          ImageUrl: result.ImageUrl,
        });
          // setTitle(result.title);
          // setDate(result.date);
          // setBackImageUrl(result.BackImageUrl);
          // setFrontImageUrl(result.FrontImageUrl);
          // setIsPublished(result.IsPublished);
  
        setContactExist(true);
      } else {
        setContactExist(false);
      }
    };
    // handle Inputs
    const handleInputs = (e) => {
      const { name, value } = e.target;
      var element;
      if (value === "" || value === "0") {
        element = document.getElementById(name);
        element.classList.add("is-invalid");
      } else {
        element = document.getElementById(name);
        element.classList.remove("is-invalid");
      }
      setContactDetails((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };
  
  
  const SetImageUrl = (e) => {
    var x = e.target.files[0];
    let reader = new FileReader();
    reader.onload = function (e) {
      if (
        e.target.result.indexOf("png") >= 0 ||
        e.target.result.indexOf("jpeg") >= 0 ||
        e.target.result.indexOf("jpg") >= 0
      ) {
        setImageToDb(x);
        setImage(e.target.result);
      } else {
        toast.error("File type error", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
    reader.readAsDataURL(e.target.files[0]);
    var element = document.getElementById("ImageUrl");
  
    element.classList.remove("is-invalid");
  
  };
  
  
  
  
  
     // Handle IsPublished
     const HandleIsPublished = () => {
      if (contactDetails.IsPublished === true) {
        setContactDetails((prevState) => ({
          ...prevState,
          IsPublished: false,
        }));
      // setIsPublished(false)
      } else {
        setContactDetails((prevState) => ({
          ...prevState,
          IsPublished: true,
        }));
      // setIsPublished(true)
  
      }
    };
  
    //#endregion
  
    // Check input validity
    function IsValid() {
      var hasError = false;
      var element;
      if (contactDetails.Number === null || contactDetails.Number === "") {
        element = document.getElementById("Number");
        element.classList.add("is-invalid");
        element.focus();
        hasError = true;
      }
     
  
      if (hasError === true) {
        return false;
      } else {
        return true;
      }
    }
  
  //   function getDateFromDetails(x) {
  //     var x = contentDetails.EventStartDate.split("-");
  //     return new Date(x[0], x[1], x[2]);
  //   }
  
    const AddNewContact = async () => {
      setButtonLoader(true);
      let response = await fetch(Variables.API_URL + "Contact/AddContact", {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          // Title: title,
          // BackImageUrl: backImageUrl,
          // FrontImageUrl: frontImageUrl,
          // Text: text,
          // IsPublished: isPublished,
          Details: contactDetails,
        }),
      });
      let result = await response.json();
      if (response.status === 200) {
        toast.success("Contact Added Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        if(imageToDb != ""){
          const formData = new FormData();
          formData.append("ImageUrl", imageToDb);
          formData.append("ContactId", result);
  
  
     
    
          const resImage = await axios.post(
            Variables.API_URL + "Contact/UploadContactMedia",
            formData,{
              headers:{
                Authorization: `Bearer ${token}`,
              }
            }
          );
  
  
    
          
        }
  
        // if(backImageUrlToDb != ""){
        //   const formData = new FormData();
        //   formData.append("BackImage", backImageUrlToDb);
        //   formData.append("AboutId", result);
    
        //   const resImage = await axios.post(
        //     Variables.API_URL + "About/UploadAboutMedia",
        //     formData,{
        //       headers:{
        //         Authorization: `Bearer ${token}`,
        //       }
        //     }
        //   );
        // }
        // if(frontImageUrlToDb != ""){
        //   const formData = new FormData();
        //   formData.append("FrontImage", frontImageUrlToDb);
        //   formData.append("AboutId", result);
    
        //   const resImage = await axios.post(
        //     Variables.API_URL + "About/UploadAboutMedia",
        //     formData,{
        //       headers:{
        //         Authorization: `Bearer ${token}`,
        //       }
        //     }
        //   );
        // }
  
  
        
  
        setTimeout(() => {
          navigate("/Contact");
        }, 1000);
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setButtonLoader(false);
    };
  
    // Update new Contact
    const UpdateContact = async () => {
      setButtonLoader(true);
      let response = await fetch(Variables.API_URL + "Contact/UpdateContact", {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          // Title: title,
          // BackImageUrl: backImageUrl,
          // FrontImageUrl: frontImageUrl,
          // Text: text,
          // IsPublished: isPublished,
          Details: contactDetails,
        }),
      });
      let result = await response.json();
      console.log(contactDetails);
      if (response.status === 200) {
        toast.success(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
  
        if(imageToDb != ""){
          const formData = new FormData();
          formData.append("ImageUrl", imageToDb);
          formData.append("ContactId", contactDetails.ContactId);
    
          const resImage = await axios.post(
            Variables.API_URL + "Contact/UploadContactMedia",
            formData,{
              headers:{
                Authorization: `Bearer ${token}`,
              }
            }
          );
        }
        setTimeout(() => {
          navigate("/Contact");
      }, 1000);
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setButtonLoader(false);
    };
  
    // Handle Sumbit
    const HandleSumbit = async () => {
      var isValid = IsValid();
      if (isValid) {
        // case of insert
        if (contactId === 0) {
          AddNewContact();
        }
        // case of update
        else {
          UpdateContact();
        }
      } else {
        toast.error("Please Fill All Required Fields", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
  
    useEffect(() => {
    
      if (contactId != 0) {
        GetContactDetails();
      }
    }, []);
  
  
    return (
      <div>
        <Row>
          <Col sm="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">
                    {contactId === 0
                      ? "Add New Contact"
                      : "Manage Contact --> " }
                  </h4>
                </div>
              </Card.Header>
              <Card.Body>
                {loader === true ? (
                  <CustomSnipper />
                ) : (
                  <div>
                    <Row>
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label htmlFor="fname">Number :</Form.Label>
                        <Form.Control
                          id="Number"
                          name="Number"
                          placeholder="Number"
                          type="text"
                          value={contactDetails.Number}
                          onChange={handleInputs}
                        />
                      </Form.Group>
  
                      
  
                     
  
                      <Form.Group className="col-md-3 form-group">
                        <Form.Label htmlFor="fname">.</Form.Label>
                        <Form.Check className="mb-3 form-check">
                          <FormCheck.Input
                            type="checkbox"
                            className=""
                            id="Published"
                            checked={contactDetails.IsPublished}
                            onChange={(e) => HandleIsPublished()}
                          />
                          <FormCheck.Label className="" htmlFor="exampleCheck1">
                            IsPublished
                          </FormCheck.Label>
                        </Form.Check>
                      </Form.Group>
  
                      
  
                      
  
                     
                      
  
                      <Form.Group className="col-lg-6 col-md-12 col-sm-12 form-group">
                        <Row>
                          <Form.Group>
                            <Form.Label className="custom-file-input">
                              Choose Image
                            </Form.Label>
                            <Form.Control
                              id="ImageUrl"
                              name="ImageUrl"
                              placeholder="Image"
                              type="file"
                              accept="image/*"
                              onChange={SetImageUrl}
                            />
                          </Form.Group>
                        </Row>
                        <Row>
                          <Col className="allignCenter">
                            {image !== "" ? (
                              <div>
                                <img
                                  src={image}
                                  className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                  alt="Boat on Calm Water"
                                />
                              </div>
                            ) : contactDetails.ImageUrl !== "" &&
                            contactDetails.ImageUrl !== null ? (
                              <div>
                                <img
                                  src={
                                    Variables.imagePath + contactDetails.ImageUrl
                                  }
                                  className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                  alt="Boat on Calm Water"
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      </Form.Group>
  
  
  
  
                    
                      
  
                      
                    </Row>
                  </div>
                )}
                <hr />
  
                <div className="float-right">
                  <Button
                    type="button"
                    variant="btn btn-primary"
                    onClick={HandleSumbit}
                  >
                    {buttonLoader == true ? (
                      <Spinner animation="border" variant="light" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    ) : (
                      "Submit"
                    )}
                  </Button>{" "}
                  <Button
                    type="button"
                    variant="btn btn-secondary"
                    onClick={() => navigate("/Contact")}
                  >
                    Cancel
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    )
}

export default ManageContact